import { DatakeyMetadataState } from "src/model/DatakeyMetadata";
import * as Actions from "src/actions/DatakeyMetadataActions";
import { DatakeyMetadataAction } from "src/actions/DatakeyMetadataActions";


const initialState: DatakeyMetadataState = {
    searchResults: [],
    searchLoading: false,
    searchError: null,
    searchNextToken: null,
    currentSearchFilters: {},
    operationLoading: false,
    multiMarketplaceResults: null,
    lastOperationResult: null,
    modalVisibility: {
        showCreateModal: false,
        showEditModal: false,
        showDeleteModal: false,
        showDetailsModal: false,
        showResultsModal: false,
    },
    modalDatakey: null,
    editingModalDatakey: null,
    creationForm: {
        datakeyName: '',
        feeType: '',
        marketplace: 'US',
        selectedMarketplaces: [],
        type: 'string',
        displayName: '',
        definition: '',
        excludeFromExplanation: false,
        valueOptions: []
    },
    createMode: 'single',
    preFillSearch: {
        publicFeeType: '',
        marketplace: 'US',
        datakeyName: ''
    },
    preFillLoading: false,
    preFillError: null,
    showPreFillSection: false,
};

export const DatakeyMetadataReducer = (state = initialState, action: DatakeyMetadataAction): DatakeyMetadataState => {
    switch (action.type) {
        case Actions.UPDATE_SEARCH_FILTERS:
            return {
                ...state,
                currentSearchFilters: action.payload
            };
        case Actions.SEARCH_DATAKEYS_REQUEST:
            return { 
                ...state, 
                searchLoading: true, 
                searchError: null,
                searchResults: [],
                currentSearchFilters: action.payload
            };
        case Actions.SEARCH_DATAKEYS_SUCCESS:
            return { 
                ...state, 
                searchLoading: false, 
                searchResults: action.payload.datakeys || [],
                searchNextToken: action.payload.nextToken || null,
                searchError: null 
            };
        case Actions.SEARCH_DATAKEYS_ERROR:
            return { 
                ...state, 
                searchLoading: false, 
                searchError: action.payload,
                searchResults: []
            };

        case Actions.LOAD_MORE_RESULTS_REQUEST:
            return {
                ...state,
                searchLoading: true,
                searchError: null
            };
        case Actions.LOAD_MORE_RESULTS_SUCCESS:
            return {
                ...state,
                searchLoading: false,
                searchResults: [...state.searchResults, ...(action.payload.datakeys || [])],
                searchNextToken: action.payload.nextToken || null,
                searchError: null
            };
        case Actions.LOAD_MORE_RESULTS_ERROR:
            return {
                ...state,
                searchLoading: false,
                searchError: action.payload
            };
        
        case Actions.CREATE_DATAKEY_MULTI_REQUEST:
            return { 
                ...state, 
                operationLoading: true,
                multiMarketplaceResults: null,
                modalVisibility: {
                    ...state.modalVisibility,
                    showResultsModal: true
                }
            };
        case Actions.CREATE_DATAKEY_MULTI_SUCCESS:
            return { 
                ...state, 
                operationLoading: false,
                multiMarketplaceResults: action.payload.results,
                modalVisibility: {
                    ...state.modalVisibility,
                    showResultsModal: true
                }
            };
        case Actions.CREATE_DATAKEY_MULTI_ERROR:
            return { 
                ...state, 
                operationLoading: false
            };
        
        case Actions.CREATE_DATAKEY_REQUEST:
            return { 
                ...state,
                operationLoading: true,
                modalVisibility: {
                    ...state.modalVisibility,
                    showResultsModal: true
                }
            };
        case Actions.CREATE_DATAKEY_SUCCESS:
            return { 
                ...state,
                operationLoading: false
            };
        case Actions.CREATE_DATAKEY_ERROR:
            return { 
                ...state,
                operationLoading: false
            };

        case Actions.UPDATE_DATAKEY_REQUEST:
            return { 
                ...state,
                operationLoading: true,
                modalVisibility: {
                    ...state.modalVisibility,
                    showResultsModal: true
                }
            };
        case Actions.UPDATE_DATAKEY_SUCCESS:
            return { 
                ...state,
                operationLoading: false
            };
        case Actions.UPDATE_DATAKEY_ERROR:
            return { 
                ...state,
                operationLoading: false
            };

        case Actions.DELETE_DATAKEY_REQUEST:
            return { 
                ...state,
                operationLoading: true,
                modalVisibility: {
                    ...state.modalVisibility,
                    showResultsModal: true
                }
            };
        case Actions.DELETE_DATAKEY_SUCCESS:
            return { 
                ...state,
                operationLoading: false
            };
        case Actions.DELETE_DATAKEY_ERROR:
            return { 
                ...state,
                operationLoading: false
            };

        case Actions.UPDATE_CREATION_FORM:
            return {
                ...state,
                creationForm: {
                    ...state.creationForm,
                    [action.payload.field]: action.payload.value
                }
            };
        case Actions.RESET_CREATION_FORM:
            return {
                ...state,
                creationForm: {
                    datakeyName: '',
                    feeType: '',
                    marketplace: 'US',
                    selectedMarketplaces: [],
                    type: 'string',
                    displayName: '',
                    definition: '',
                    excludeFromExplanation: false,
                    valueOptions: []
                }
            };
        case Actions.SET_CREATE_MODE:
            return {
                ...state,
                createMode: action.payload
            };

        case Actions.UPDATE_PREFILL_SEARCH:
            return {
                ...state,
                preFillSearch: {
                    ...state.preFillSearch,
                    [action.payload.field]: action.payload.value
                }
            };
        case Actions.PREFILL_FROM_EXISTING_REQUEST:
            return {
                ...state,
                preFillLoading: true,
                preFillError: null
            };
        case Actions.PREFILL_FROM_EXISTING_SUCCESS:
            return {
                ...state,
                preFillLoading: false,
                preFillError: null,
                showPreFillSection: false,
                creationForm: {
                    datakeyName: '',
                    feeType: action.payload.datakey.publicFeeType,
                    marketplace: action.payload.datakey.marketplace,
                    selectedMarketplaces: [action.payload.datakey.marketplace],
                    type: action.payload.datakey.attributes.type,
                    displayName: action.payload.datakey.attributes.displayName,
                    definition: action.payload.datakey.attributes.definition,
                    excludeFromExplanation: action.payload.datakey.attributes.excludeFromExplanation,
                    valueOptions: [...(action.payload.datakey.attributes.valueOptions || [])]
                }
            };
        case Actions.PREFILL_FROM_EXISTING_ERROR:
            return {
                ...state,
                preFillLoading: false,
                preFillError: action.payload
            };
        case Actions.TOGGLE_PREFILL_SECTION:
            return {
                ...state,
                showPreFillSection: !state.showPreFillSection
            };

        case Actions.SET_OPERATION_RESULT:
            return {
                ...state,
                lastOperationResult: action.payload,
                modalVisibility: {
                    ...state.modalVisibility,
                    showResultsModal: true
                }
            };
        case Actions.CLEAR_OPERATION_RESULT:
            return {
                ...state,
                lastOperationResult: null,
                multiMarketplaceResults: null,
                modalVisibility: {
                    ...state.modalVisibility,
                    showResultsModal: false
                }
            };

        case Actions.SHOW_MODAL:
            return {
                ...state,
                modalVisibility: {
                    ...state.modalVisibility,
                    [action.payload]: true
                }
            };
        case Actions.HIDE_MODAL:
            return {
                ...state,
                modalVisibility: {
                    ...state.modalVisibility,
                    [action.payload]: false
                }
            };
        case Actions.HIDE_ALL_MODALS:
            return {
                ...state,
                modalVisibility: {
                    showCreateModal: false,
                    showEditModal: false,
                    showDeleteModal: false,
                    showDetailsModal: false,
                    showResultsModal: false,
                },
                modalDatakey: null,
                editingModalDatakey: null
            };

        case Actions.SET_MODAL_DATAKEY:
            return {
                ...state,
                modalDatakey: action.payload
            };
        case Actions.SET_EDITING_MODAL_DATAKEY:
            return {
                ...state,
                editingModalDatakey: action.payload
            };
        case Actions.CLEAR_MODAL_DATA:
            return {
                ...state,
                modalDatakey: null,
                editingModalDatakey: null
            };
        case Actions.UPDATE_EDITING_MODAL_DATAKEY:
            return {
                ...state,
                editingModalDatakey: state.editingModalDatakey ? {
                    ...state.editingModalDatakey,
                    attributes: {
                        ...state.editingModalDatakey.attributes,
                        [action.payload.field]: action.payload.value
                    }
                } : null
            };

        default:
            return state;
    }
};

export default DatakeyMetadataReducer;
